import { api } from './api';

// Predefined task templates that users can configure
export const PREDEFINED_TASKS = {
  user: [
    {
      id: 'allergy-vaccine',
      name: 'Allergi-vaccination',
      description: 'Påmindelse om allergi-vaccination',
      category: 'health',
      icon: 'Activity'
    },
    {
      id: 'medicine',
      name: 'Medicin',
      description: 'Påmindelse om at tage medicin',
      category: 'health',
      icon: 'Pill'
    },
    {
      id: 'doctor-appointment',
      name: 'Lægetid',
      description: 'Påmindelse om kommende lægetid',
      category: 'health',
      icon: 'Stethoscope'
    },
    {
      id: 'medicine-expired',
      name: 'Udløb af medicin',
      description: 'Påmindelse om at købe ny medicin',
      category: 'health',
      icon: 'AlertTriangle'
    },
    {
      id: 'cleaning',
      name: 'Rengøring og støvsugning',
      description: 'Påmindelse om rengøring og støvsugning',
      category: 'home',
      icon: 'Home'
    },
    {
      id: 'wash-textiles',
      name: 'Vask af tekstiler ved 60°',
      description: 'Påmindelse om at vaske tekstiler ved 60 grader',
      category: 'home',
      icon: 'Droplets'
    },
    {
      id: 'drink-water',
      name: 'Drik vand',
      description: 'Påmindelse om at drikke vand',
      category: 'health',
      icon: 'Droplets'
    },
    {
      id: 'air-filter',
      name: 'Rens af forfilter',
      description: 'Påmindelse om at rense luftrenserens forfilter',
      category: 'home',
      icon: 'Wind'
    }
  ],
  system: [
    {
      id: 'sunscreen-summer',
      name: 'Påsmøring af solcreme',
      description: 'Påmindelse om solcreme op til sommeren (obligatorisk)',
      category: 'health',
      icon: 'Sun',
      mandatory: true
    },
    {
      id: 'vitamin-d-winter',
      name: 'D-vitamin supplement',
      description: 'Påmindelse om D-vitamin op til vinteren (obligatorisk)',
      category: 'health',
      icon: 'Moon',
      mandatory: true
    }
  ]
};

export const notificationService = {
  getNotifications: async () => {
    try {
      return await api.get('/api/notifications');
    } catch (error) {
      console.error('Error fetching notifications:', error);
      return [];
    }
  },

  // Get user's notification settings
  getNotificationSettings: async () => {
    const seeds = ['/api/notifications/settings', '/notifications/settings', '/api/settings/notifications'];
    for (const url of seeds) {
      try {
        return await api.get(url);
      } catch (error) {
        console.warn(`notification settings fetch failed for ${url}, trying next`, error);
      }
    }
    console.warn('notification settings unavailable, using defaults');
    return {
      enabledTasks: [],
      notificationTiming: 'on-time',
      taskSettings: {}
    };
  },

  // Update notification settings
  updateNotificationSettings: async (settings) => {
    const paths = ['/api/notifications/settings', '/notifications/settings', '/api/settings/notifications'];
    let lastError;
    for (const path of paths) {
      try {
        return await api.post(path, settings);
      } catch (error) {
        console.warn(`updateNotificationSettings failed for ${path}`, error);
        lastError = error;
      }
    }
    console.error('Error updating notification settings:', lastError);
    throw lastError;
  },

  // Enable a task template for the user
  enableTask: async (taskId, schedule) => {
    const paths = ['/api/notifications/tasks/enable', '/notifications/tasks/enable'];
    let lastError;
    for (const path of paths) {
      try {
        return await api.post(path, {
          taskId,
          ...schedule
        });
      } catch (error) {
        console.warn(`enableTask failed for ${path}`, error);
        lastError = error;
      }
    }
    console.error('Error enabling task:', lastError);
    throw lastError;
  },

  // Disable a task template for the user
  disableTask: async (taskId) => {
    const paths = ['/api/notifications/tasks/disable', '/notifications/tasks/disable'];
    let lastError;
    for (const path of paths) {
      try {
        return await api.post(path, { taskId });
      } catch (error) {
        console.warn(`disableTask failed for ${path}`, error);
        lastError = error;
      }
    }
    console.error('Error disabling task:', lastError);
    throw lastError;
  },

  // Update task-specific settings (timing, recurrence, etc)
  updateTaskSettings: async (taskId, settings) => {
    try {
      return await api.patch(`/api/notifications/tasks/${taskId}`, settings);
    } catch (error) {
      console.error('Error updating task settings:', error);
      throw error;
    }
  },

  // Get upcoming notifications
  getUpcomingNotifications: async () => {
    try {
      return await api.get('/api/notifications/upcoming');
    } catch (error) {
      console.error('Error fetching notifications:', error);
      return [];
    }
  },

  // Mark notification as handled
  handleNotification: async (notificationId, action) => {
    // action: 'done', 'postpone', 'ignore'
    try {
      return await api.post(`/api/notifications/${notificationId}/handle`, {
        action
      });
    } catch (error) {
      console.error('Error handling notification:', error);
      throw error;
    }
  }
};
